import React from 'react';
import { useDesignTokens } from '@sas/nova-commons/theme';
import { ColorPicker } from '@sas/nova-commons/components/ColorPicker';
import { getDefaultFeatureColor, getFeatureTokens } from '../../utils/tokens';
export const FeatureColorPicker = (props) => {
    const dt = useDesignTokens();
    return (React.createElement(ColorPicker, { automaticColor: getDefaultFeatureColor(dt), selectedColor: {
            color: getFeatureTokens(dt, props.feature).fg,
            type: props.feature.color === null ? 'automatic' : 'standard',
        }, onColorChange: ({ color, type }) => {
            props.onColorChange(type === 'automatic' ? null : color);
        }, hideNoColor: true }));
};
